var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738281 11.5625L6.23438 1.96484L7 0.625L7.73828 1.96484L13.2344 11.5625L14 12.875H12.4688H1.50391H0L0.738281 11.5625ZM11.7305 11.5625L7 3.27734L2.24219 11.5625H11.7305ZM6.34375 7.84375V5.4375H7.65625V7.84375V8.5H6.34375V7.84375ZM7.65625 10.6875H6.34375V9.375H7.65625V10.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.7f68a15ee35a4916fe6b80c78a3409c0.svg";
export { ForwardRef as ReactComponent };